// extracted by mini-css-extract-plugin
module.exports = {"firstStepLabel":"styles_firstStepLabel__1LzdZ","lastStepLabel":"styles_lastStepLabel__1taVS"};